import { useUser } from "hooks/useUser"
import ConventionUserExhibitorFavorite from "models/convention-api/v1/ConventionUserExhibitorFavorite"
import { useMemo } from "react"

export const useFavoriteExhibitorIds = () => {
  const user = useUser()

  const favoriteExhibitors = ConventionUserExhibitorFavorite.useAll(() => {
    if (!user) return null
    return {}
  })

  const favoriteExhibitorIds: undefined | string[] = useMemo(() => {
    if (!favoriteExhibitors.data) return undefined
    if (favoriteExhibitors.data.length === 0) return []
    return favoriteExhibitors.data.map(
      (favoriteExhibitor) => favoriteExhibitor.convention_provider_exhibitor_id,
    )
  }, [user, favoriteExhibitors.data])

  return favoriteExhibitorIds
}
